import { render, staticRenderFns } from "./CommentView.vue?vue&type=template&id=3b96e690&"
import script from "./CommentView.vue?vue&type=script&lang=js&"
export * from "./CommentView.vue?vue&type=script&lang=js&"
import style0 from "./CommentView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports